export default {
  getEvent: state => (eventId) => state.clubClasses.find((event) => event.id == eventId),
}

